import { render } from "./AccountEditor.vue?vue&type=template&id=48defffa&scoped=true&ts=true"
import script from "./AccountEditor.vue?vue&type=script&lang=ts"
export * from "./AccountEditor.vue?vue&type=script&lang=ts"

import "./AccountEditor.vue?vue&type=style&index=0&id=48defffa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48defffa"]])

export default __exports__